module.exports = __webpack_public_path__ + "media/images/emblems/Orsieres-b560cf98cd2bae847554dacea67177ce.png";